<template>
  <v-fade-transition mode="out-in">
    <v-btn
      :key="$vuetify.theme.dark"
      icon
      class="admin-icon-button"
      :aria-label="$vuetify.theme.dark ? 'Açık tema' : 'Koyu tema'"
      :title="$vuetify.theme.dark ? 'Açık tema' : 'Koyu tema'"
      @click="toggleTheme"
    >
      <v-icon>
        {{ $vuetify.theme.dark ? icons.mdiWeatherSunny : icons.mdiWeatherNight }}
      </v-icon>
    </v-btn>
  </v-fade-transition>
</template>

<script>
import { mdiWeatherNight, mdiWeatherSunny } from '@mdi/js'

export default {
  methods: {
    toggleTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      localStorage.setItem('admin-theme-dark', String(this.$vuetify.theme.dark))
    },
  },
  setup() {
    return {
      icons: {
        mdiWeatherNight,
        mdiWeatherSunny,
      },
    }
  },
}
</script>

<style>
</style>
